import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Dashboard } from './components/Dashboard';
import { PasswordGate } from './components/Auth/PasswordGate';
import { PricingPage } from './components/Subscription/PricingPage';
import { InviteAccept } from './components/Auth/InviteAccept';
import LandingPage from './pages/LandingPage';
import { useFileParser } from './hooks/useFileParser';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LocationProvider } from './contexts/LocationContext';
import { TeamProvider } from './contexts/TeamContext';
import { Loader2 } from 'lucide-react';

function AppContent() {
  const { services, isLoading, error, fileName, parseFile, clearData, loadServices } = useFileParser();
  const { isAuthenticated, isLoading: authLoading, logout, user, subscription } = useAuth();
  const [showDashboard, setShowDashboard] = useState(false);
  const [showPricing, setShowPricing] = useState(false);

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-blue-400 animate-spin" />
      </div>
    );
  }

  // Show password gate if not authenticated
  if (!isAuthenticated || !showDashboard) {
    return <PasswordGate onAuthenticated={() => setShowDashboard(true)} />;
  }

  return (
    <>
      {error && (
        <div className="fixed top-4 right-4 z-50 bg-red-500/90 text-white px-4 py-3 rounded-lg shadow-lg max-w-md">
          <p className="font-medium">Error parsing file</p>
          <p className="text-sm opacity-90">{error}</p>
        </div>
      )}
      {/* Pricing Modal */}
      {showPricing && <PricingPage onClose={() => setShowPricing(false)} />}
      
      <Dashboard
        userEmail={user?.email}
        plan={subscription?.plan || 'free'}
        onUpgradeClick={() => setShowPricing(true)}
        onLogout={logout}
        services={services}
        fileName={fileName}
        isLoading={isLoading}
        onFileSelect={parseFile}
        onClear={clearData}
        onLoadServices={loadServices}
      />
    </>
  );
}

// Invite page wrapper
function InvitePage() {
  return <InviteAccept onComplete={() => window.location.href = '/'} />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LocationProvider>
          <TeamProvider>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/app/*" element={<AppContent />} />
              <Route path="/invite" element={<InvitePage />} />
            </Routes>
          </TeamProvider>
        </LocationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
